import { Box } from '@bridebook/ui';
import componentStyles from '@bridebook/web/components/articles/placeholders/article-tile-placeholder.style';

const ArticleTilePlaceholder = () => {
  const styles = componentStyles();
  return (
    <Box style={styles.wrapper}>
      <Box style={styles.image} />
      <Box style={styles.content}>
        <Box style={styles.title} />
        <Box style={styles.title} />
        <Box style={styles.tag} />
      </Box>
    </Box>
  );
};

export default ArticleTilePlaceholder;
